import {
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { VRSTA_OPERATERA, VRSTA_ZAHTJEVA } from "../../../../enums";
import { VrstaZahtjeva } from "../../../index";
import { useFormContext } from "react-hook-form";
import { ChangeEvent, useEffect } from "react";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);

const Index = ({ trenutniDatum }: any) => {
  const { register, getValues, setValue, watch } = useFormContext();
  const watchVrstaOperatera = watch("operaterPlatforme.vrstaOperatera.id");
  const watchTrenutniDatumOP = trenutniDatum;
  const trenutniDatumOP = trenutniDatum;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { target } = e;
    const { value } = target;

    setValue("operaterPlatforme.vrstaOperatera.id", value);
    setValue("vrstaZahtjeva", VRSTA_ZAHTJEVA.REGISTRACIJA);
  };

  useEffect(() => {
    setValue(
      "operaterPlatforme.primarniIdentifikator.tip",
      parseInt(watchVrstaOperatera) === VRSTA_OPERATERA.IZ_RH
        ? "primarni OIB"
        : "primarni TIN"
    );
    setValue(
      "operaterPlatforme.primarniIdentifikator.drzavaIzdavatelj.oznaka",
      parseInt(watchVrstaOperatera) === VRSTA_OPERATERA.IZ_RH ? "HRV" : ""
    );
    // setValue("vrstaZahtjeva", VRSTA_ZAHTJEVA.REGISTRACIJA);
  }, [watchVrstaOperatera]);

  useEffect(() => {
    if (
      dayjs(trenutniDatumOP).isBetween(
        "2023-10-01",
        dayjs("2023-10-31"),
        "day",
        "[]"
      )
    ) {
      setValue("operaterPlatforme.vrstaOperatera.id", VRSTA_OPERATERA.IZVAN_EU);
      setValue("vrstaZahtjeva", VRSTA_ZAHTJEVA.REGISTRACIJA);
    }
    if (
      dayjs(trenutniDatumOP).isBetween(
        "2023-11-01",
        dayjs("2024-01-31"),
        "day",
        "[]"
      )
    ) {
      setValue("operaterPlatforme.vrstaOperatera.id", VRSTA_OPERATERA.IZ_RH);
    }
    if (
      dayjs(trenutniDatumOP).isBetween(
        "2023-11-01",
        dayjs("2023-12-31"),
        "day",
        "[]"
      )
    ) {
      setValue("vrstaZahtjeva", VRSTA_ZAHTJEVA.ISKLJUCENJE);
      setValue(
        "operaterPlatforme.vrstaOperatera.id",
        VRSTA_OPERATERA.IZ_RH_ISKLJUCENI
      );
    }
    if (
      dayjs(trenutniDatumOP).isBetween(
        "2024-01-01",
        dayjs("2024-01-31"),
        "day",
        "[]"
      )
    ) {
      setValue("vrstaZahtjeva", VRSTA_ZAHTJEVA.REGISTRACIJA);
    }

    if (dayjs(trenutniDatumOP).isAfter("2024-01-31")) {
      setValue("operaterPlatforme.vrstaOperatera.id", VRSTA_OPERATERA.IZ_RH);
      setValue("vrstaZahtjeva", VRSTA_ZAHTJEVA.REGISTRACIJA);
    }
  }, [watchTrenutniDatumOP]);

  return (
    <Card variant={"outlined"}>
      <CardContent>
        {trenutniDatumOP && (
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            value={getValues("operaterPlatforme.vrstaOperatera.id")}
            name="radio-buttons-group"
            onChange={handleChange}
          >
            {(dayjs(trenutniDatumOP).isBetween(
              "2023-11-01",
              dayjs("2024-01-31"),
              "day",
              "[]"
            ) ||
              dayjs(trenutniDatumOP).isAfter("2024-01-31")) && (
              <FormControl>
                <FormControlLabel
                  value={
                    dayjs(trenutniDatumOP).isBetween(
                      "2023-11-01",
                      dayjs("2023-12-31"),
                      "day",
                      "[]"
                    )
                      ? VRSTA_OPERATERA.IZ_RH_ISKLJUCENI
                      : VRSTA_OPERATERA.IZ_RH
                  }
                  control={
                    <Radio
                      {...register("operaterPlatforme.vrstaOperatera.id")}
                    />
                  }
                  label="Operater platforme iz RH (Croatian Platform Operator)"
                />
                <VrstaZahtjeva trenutniDatum={trenutniDatum} />
              </FormControl>
            )}
            {(dayjs(trenutniDatumOP).isBetween(
              "2023-10-01",
              dayjs("2023-10-31"),
              "day",
              "[]"
            ) ||
              dayjs(trenutniDatumOP).isAfter("2024-01-31")) && (
              <FormControl>
                <FormControlLabel
                  value={VRSTA_OPERATERA.IZVAN_EU}
                  control={
                    <Radio
                      {...register("operaterPlatforme.vrstaOperatera.id")}
                    />
                  }
                  label="Operater platforme izvan EU (Non-EU Platform Operator)"
                />
              </FormControl>
            )}
          </RadioGroup>
        )}
      </CardContent>
    </Card>
  );
};

export default Index;
